import { FilterUsers } from 'src/models/filter';

import { Callback } from 'src/util/query/models/Callback';

import { IdoActivityHistoryListCallbackStoreContract } from '../interfaces';

export class GetAllUsersWithAccessToTheModuleForTheUserFilterIdoActivityHistoryListCallBack extends Callback<
	Array<FilterUsers>
> {
	public constructor(
		private readonly store: IdoActivityHistoryListCallbackStoreContract,
		private readonly uniqueListIdentifier: string,
		private readonly aggregateId: string
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Array<FilterUsers>): void => {
		this.store.setFilterUsersValue({
			aggregateId: this.aggregateId,
			payload: successResponse,
			uniqueListIdentifier: this.uniqueListIdentifier,
		});
	};
}
